// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_CANCEL_EDIT_CUOTA,
} from './constants';

export function cancelEditCuota(id) {
  return {
    type: SIMULADOR_FINANCIERO_CANCEL_EDIT_CUOTA,
    id: id
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_CANCEL_EDIT_CUOTA:
      if (state.editLinea) {
        let editLineaData = state.editLineaData;
        let cuotas = state.editLineaData.datosFinancieros.cuotas;
        let cuotasPreviousValues = state.editLineaData.datosFinancieros.cuotasPreviousValues;
        let cuotaAux = cuotasPreviousValues.find((cuota) => {
          return cuota.id === action.id;
        });
        cuotas.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.plazo = cuotaAux.plazo;
            cuota.montoMax = cuotaAux.montoMax;
            cuota.tna = cuotaAux.tna;
            cuota.valorCuotaPromedio = cuotaAux.valorCuotaPromedio;
            cuota.porcMaxFinanciar = cuotaAux.porcMaxFinanciar;
            cuota.quebranto = cuotaAux.quebranto;
            cuota.gastos = cuotaAux.gastos;
            cuota.cft = cuotaAux.cft;
            cuota.showEdit = true;
            cuota.showDelete = true;
          }
        });
        editLineaData.datosFinancieros.cuotas = [...cuotas];

        return {
          ...state,
          editLineaData: editLineaData
        };
      } else {
        let altaNuevaLinea = state.altaNuevaLinea;
        let cuotas = state.altaNuevaLinea.datosFinancieros.cuotas;
        let cuotasPreviousValues = state.altaNuevaLinea.datosFinancieros.cuotasPreviousValues;
        let cuotaAux = cuotasPreviousValues.find((cuota) => {
          return cuota.id === action.id;
        });
        cuotas.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.plazo = cuotaAux.plazo;
            cuota.montoMax = cuotaAux.montoMax;
            cuota.tna = cuotaAux.tna;
            cuota.valorCuotaPromedio = cuotaAux.valorCuotaPromedio;
            cuota.porcMaxFinanciar = cuotaAux.porcMaxFinanciar;
            cuota.quebranto = cuotaAux.quebranto;
            cuota.gastos = cuotaAux.gastos;
            cuota.cft = cuotaAux.cft;
            cuota.showEdit = true;
            cuota.showDelete = true;
          }
        });
        altaNuevaLinea.datosFinancieros.cuotas = [...cuotas];

        return {
          ...state,
          altaNuevaLinea: altaNuevaLinea
        };
      }


    default:
      return state;
  }
}
